<div class="page flex justify-center">
  <div class="w-full max-w-md">
    <div class="mb-8 flex flex-col items-center justify-center text-center text-accent">
      <app-brand-logo class="mb-2 h-20 w-20" />
      <span class="brand-wordmark text-3xl text-slate-900 dark:text-slate-100">CANI<span class="brand-apostrophe">'</span>TRACK</span>
    </div>

    <div class="card p-8 md:p-10">
      <h1 class="auth-title mb-8">{{ 'login.title' | translate }}</h1>

      <form [formGroup]="loginForm" (ngSubmit)="onSubmit()" class="space-y-6" novalidate>
        @if (errorMessage(); as msg) {
          <app-auth-alert>
            <p>{{ msg | translate }}</p>
            @if (unconfirmedEmail()) {
              <button type="button" (click)="resendConfirmation()" [disabled]="isResending()"
                class="mt-3 underline underline-offset-2 hover:no-underline disabled:opacity-60">
                {{ (isResending() ? 'auth.confirm.resending' : 'auth.confirm.resend') | translate }}
              </button>
            }
          </app-auth-alert>
        }
        @if (resentTo(); as email) {
          <app-auth-alert tone="success">{{ 'auth.confirm.resent' | translate: email }}</app-auth-alert>
        }

        <div>
          <label for="email" class="field-label">{{ 'login.email' | translate }}</label>
          <input type="email" id="email" formControlName="email" class="field" autocomplete="email" required>
          @if (fieldError(loginForm.controls.email); as err) {
            <p class="mt-2 text-xs font-semibold text-red-600 dark:text-red-400">{{ err.key | translate: err.arg }}</p>
          }
        </div>

        <div>
          <div class="flex items-baseline justify-between gap-4">
            <label for="password" class="field-label">{{ 'login.password' | translate }}</label>
            <a routerLink="/forgot-password" [queryParams]="loginForm.controls.email.valid ? { email: loginForm.controls.email.value } : {}"
              class="link-accent text-xs">{{ 'auth.forgot.link' | translate }}</a>
          </div>
          <input type="password" id="password" formControlName="password" class="field" autocomplete="current-password" required>
          @if (fieldError(loginForm.controls.password); as err) {
            <p class="mt-2 text-xs font-semibold text-red-600 dark:text-red-400">{{ err.key | translate: err.arg }}</p>
          }
        </div>

        <div class="flex flex-col sm:flex-row-reverse gap-4">
          <button type="submit" [disabled]="isLoading()"
            class="btn btn-primary w-full">
            @if (isLoading()) {
              <app-branded-loader mode="inline" [label]="'login.loading' | translate" />
            } @else {
              {{ 'login.button' | translate }}
            }
          </button>
          <button type="button" (click)="onCancel()"
            class="btn btn-secondary w-full">
            {{ 'login.cancel' | translate }}
          </button>
        </div>

        <p class="text-center text-sm text-slate-500 dark:text-slate-400 mt-4">
          {{ 'login.noAccount' | translate }}
          <a routerLink="/register" class="link-accent ml-1">{{ 'login.registerLink' | translate }}</a>
        </p>
      </form>
    </div>
  </div>
</div>
